export default __webpack_public_path__ + "static/media/Snd3.a4aa03aa.mp3";